import { useContext } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

import { MainContext, checkIsIframe, useTranslation } from '@ezbobdev/ui-framework';

import { systemEvents } from '../../utils/constants';

const IframeCloseButton = () => {
  const { actions } = useContext(MainContext);
  const { t } = useTranslation();

  const showCloseButton = actions.settings.getUserConfigProp('iframe.showCloseButton') ?? false;

  if (!checkIsIframe() || !showCloseButton) return null;

  return (
    <IconButton
      aria-label={t('globals.close')}
      onClick={() => actions.events.emit(systemEvents.GL_ABANDON)}
      sx={{
        position: 'fixed',
        top: 8,
        insetInlineEnd: 8,
        zIndex: 1300,
        color: 'text.secondary',
      }}
    >
      <CloseIcon />
    </IconButton>
  );
};

export default IframeCloseButton;
